import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Select,
  MenuItem,
  InputAdornment,
  Button,
  Chip,
  Typography,
  FormControl,
  InputLabel,
  Grid,
  CircularProgress,
  Tooltip,
  IconButton,
  Collapse,
  Alert,
  Stack,
  Popper,
  ClickAwayListener,
  Paper as PopperPaper,
  MenuList,
  Grow,
  RadioGroup,
  Radio,
  FormControlLabel, OutlinedInput
} from '@mui/material';
import {
  Search as SearchIcon,
  Storefront as StorefrontIcon,
  Clear,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  AccessTime as AccessTimeIcon,
  GridOn as GridOnIcon,
  BarChart as BarChartIcon,
  CalendarToday as CalendarIcon,
  Schedule as ScheduleIcon,
  HourglassBottom as HourglassBottomIcon,
  HourglassTop as HourglassTopIcon,
  Category,
  TableChart,
  PictureAsPdf
} from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { getPeakHoursData, downloadExcelGetPeakHoursItems, downloadPDFGetPeakHoursItemsReport, getOutletTimings } from '../services/reportService';
import outletService from '../services/outletService';
import menuService from '../services/menuService';


// All 24 hours for time filter
const allHours = Array.from({ length: 24 }, (_, i) =>
  String(i).padStart(2, '0') + ':00'
);

// Custom Time Select Component with fixed scrolling
// const CustomTimeSelect = ({ label, value, onChange, placeholder, icon: Icon, timeIndex }) => {
//   const [open, setOpen] = useState(false);
//   const anchorRef = useRef(null);

//   const handleToggle = () => {
//     setOpen((prevOpen) => !prevOpen);
//   };

//   const handleClose = (event) => {
//     if (anchorRef.current && anchorRef.current.contains(event.target)) {
//       return;
//     }
//     setOpen(false);
//   };

//   const handleSelect = (hour) => {
//     let indexHour = parseInt(hour.split(":")[0], 10);
//     timeIndex(indexHour)
//     onChange(hour);
//     setOpen(false);
//   };

//   const handleListKeyDown = (event) => {
//     if (event.key === 'Tab') {
//       event.preventDefault();
//       setOpen(false);
//     } else if (event.key === 'Escape') {
//       setOpen(false);
//     }
//   };

//   return (
//     <Box>
//       <TextField
//         ref={anchorRef}
//         fullWidth
//         size="small"
//         label={label}
//         value={value || ''}
//         placeholder={placeholder}
//         onClick={handleToggle}
//         sx={{ zIndex: 1 }}  // Use sx prop instead of mt in InputProps
//         InputProps={{
//           readOnly: true,
//           startAdornment: Icon && (
//             <InputAdornment position="start">
//               <Icon fontSize="small" />
//             </InputAdornment>
//           ),
//         }}
//         InputLabelProps={{
//           shrink: true,
//         }}
//       />
//       <Popper
//         open={open}
//         anchorEl={anchorRef.current}
//         role={undefined}
//         placement="bottom-start"
//         transition
//         disablePortal
//         style={{ zIndex: 9999 }}
//       >
//         {({ TransitionProps, placement }) => (
//           <Grow
//             {...TransitionProps}
//             style={{
//               transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
//             }}
//           >
//             <PopperPaper>
//               <ClickAwayListener onClickAway={handleClose}>
//                 <MenuList
//                   id="split-button-menu"
//                   autoFocusItem={open}
//                   onKeyDown={handleListKeyDown}
//                   sx={{
//                     maxHeight: 300,
//                     overflowY: 'auto',
//                     width: anchorRef.current?.offsetWidth || 'auto'
//                   }}
//                 >
//                   <MenuItem
//                     value=""
//                     onClick={() => handleSelect('')}
//                     sx={{ fontWeight: 'bold' }}
//                   >
//                     Clear Selection
//                   </MenuItem>
//                   {allHours.map((hour) => (
//                     <MenuItem
//                       key={hour}
//                       selected={value === hour}
//                       onClick={() => handleSelect(hour)}
//                     >
//                       {hour}
//                     </MenuItem>
//                   ))}
//                 </MenuList>
//               </ClickAwayListener>
//             </PopperPaper>
//           </Grow>
//         )}
//       </Popper>
//     </Box>
//   );
// };


const CustomTimeSelect = ({ label, value, onChange, placeholder, icon: Icon, timeIndex, timeSlots }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleSelect = (hour) => {
    // Find the actual index in the timeSlots array
    const actualIndex = timeSlots.indexOf(hour);
    timeIndex(actualIndex !== -1 ? actualIndex : 0);
    onChange(hour);
    setOpen(false);
  };
  const handleListKeyDown = (event) => {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth size="small" sx={{ mt: 1 }}>
        <InputLabel shrink={true}>{label}</InputLabel>
        <OutlinedInput
          ref={anchorRef}
          value={value || ''}
          placeholder={placeholder}
          onClick={handleToggle}
          readOnly
          label={label}
          startAdornment={Icon && (
            <InputAdornment position="start">
              <Icon fontSize="small" />
            </InputAdornment>
          )}
          notched={true}
        />
      </FormControl>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        placement="bottom-start"
        transition
        disablePortal
        style={{ zIndex: 9999 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
            }}
          >
            <PopperPaper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  id="split-button-menu"
                  autoFocusItem={open}
                  onKeyDown={handleListKeyDown}
                  sx={{
                    maxHeight: 300,
                    overflowY: 'auto',
                    width: anchorRef.current?.offsetWidth || 'auto'
                  }}
                >
                  <MenuItem
                    value=""
                    onClick={() => handleSelect('')}
                    sx={{ fontWeight: 'bold' }}
                  >
                    Clear Selection
                  </MenuItem>
                  {allHours.map((hour) => (
                    <MenuItem
                      key={hour}
                      selected={value === hour}
                      onClick={() => handleSelect(hour)}
                    >
                      {hour}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </PopperPaper>
          </Grow>
        )}
      </Popper>
    </Box>
  );
};

function PeakHoursItemsManagement() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState('');
  const [selectedOutlet, setSelectedOutlet] = useState('all');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startTime, setStartTime] = useState('00:00');
  const [endTime, setEndTime] = useState('23:00');
  const [selectedView, setSelectedView] = useState('grid');
  const [peakData, setPeakData] = useState({});
  const [timeSlots, setTimeSlots] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedRows, setExpandedRows] = useState({});
  const [outlets, setOutlets] = useState([])
  const [dateFilter, setDateFilter] = useState('thisWeek');
  const [categories, setCategories] = useState([])
  const [selectedCategory, setSelectedCategory] = useState("all")
  const [viewType, setViewType] = useState("quantity")
  const [startTimeIndex, setStartTimeIndex] = useState(0);
  const [endTimeIndex, setEndTimeIndex] = useState(23);


  useEffect(() => {
    fetchPeakData();
    fetchOutlets();
    fetchCategories();
    if(JSON.parse(localStorage.getItem('admin_outlet_id'))){
      setSelectedOutlet(JSON.parse(localStorage.getItem('admin_outlet_id')));
    }
  }, [selectedOutlet, startDate, endDate, startTime, endTime, selectedCategory, viewType,dateFilter]);

  useEffect(() => {
    fetchOutletTiming()
  }, [selectedOutlet, timeSlots])

  const fetchOutlets = async () => {
    try {
      const response = await outletService.getOutlets()
      // const outletsData = await response.json();
      setOutlets(response);

    } catch (error) {
      // console.error('Error fetching outlets:', error);
    }
  };

  const fetchOutletTiming = async () => {
    try {
      const response = await getOutletTimings(selectedOutlet);
      // console.log(response);

      // Set the time values
      setStartTime(response.result.start_time);
      setEndTime(response.result.end_time);

      // Find the indices in the timeSlots array
      const startIdx = timeSlots.indexOf(response.result.start_time);
      const endIdx = timeSlots.indexOf(response.result.end_time);

      // Set the indices if found, otherwise use defaults
      setStartTimeIndex(startIdx !== -1 ? startIdx : 0);
      setEndTimeIndex(endIdx !== -1 ? endIdx : 23);
    } catch (error) {
      // console.error(error);
      // Set defaults if API fails
      setStartTimeIndex(0);
      setEndTimeIndex(23);
      setStartTime('00:00');
      setEndTime('23:00');
    }
  };

  const fetchCategories = async () => {
    try {
      const data = await menuService.getCategories();
      setCategories(data);
    } catch (err) {
      // console.error('Failed to fetch categories:', err);
    }
  }

  const formatLocalDate = (date) => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const fetchPeakData = async () => {
    setLoading(true);
    try {
      // Prepare request parameters
      const params = {
        outlet_id: selectedOutlet === 'all' ? null : selectedOutlet,
        date_filter: dateFilter !== 'all' && dateFilter !== "custom" ? dateFilter : null,
        start_date: dateFilter === "custom" && startDate ? formatLocalDate(startDate) : null,
        end_date: dateFilter === "custom" && endDate ? formatLocalDate(endDate) : null,
        category_id: selectedCategory !== 'all' ? selectedCategory : null,
        start_time: startTime,
        end_time: endTime
      };

      // Call actual API
      const response = await getPeakHoursData(params);
      // console.log("Peak Response => ", response);

      if (response && response.data) {
        const { items: itemList, timeSlots: timeSlotList, data: matrixData, price: priceData } = response;

        setItems(itemList || []);
        setTimeSlots(timeSlotList || []);

        // Convert matrix data to object format for easier access
        const formattedData = {};
        if (viewType === "quantity") {
          if (itemList && matrixData) {
            itemList.forEach((item, index) => {
              formattedData[item] = {};
              if (timeSlotList) {
                timeSlotList.forEach((slot, slotIndex) => {
                  formattedData[item][slot] = matrixData[index]?.[slotIndex] || 0;
                });
              }
            });
          }
        }
        else {
          if (itemList && priceData) {
            itemList.forEach((item, index) => {
              formattedData[item] = {};
              if (timeSlotList) {
                timeSlotList.forEach((slot, slotIndex) => {
                  formattedData[item][slot] = priceData[index]?.[slotIndex] || 0;
                });
              }
            });
          }
        }


        setPeakData(formattedData);
      }
    } catch (error) {
      // console.error("Error fetching peak hours data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fallback mock data generator (if API fails)
  const generateFallbackData = () => {
    const fallbackItems = [
      "Achari Chicken", "Chicken", "Paneer", "Fish",
      "Biryani", "Naan", "Roti", "Daal", "Rice", "Curry"
    ];
    const fallbackTimeSlots = [
      "00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00",
      "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00",
      "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"
    ];

    const data = {};
    fallbackItems.forEach(item => {
      data[item] = {};
      fallbackTimeSlots.forEach(slot => {
        const hour = parseInt(slot.split(':')[0]);
        let baseValue = 0;
        if (hour >= 12 && hour <= 14) baseValue = Math.floor(Math.random() * 30) + 20;
        else if (hour >= 19 && hour <= 21) baseValue = Math.floor(Math.random() * 25) + 15;
        else if (hour >= 8 && hour <= 11) baseValue = Math.floor(Math.random() * 10) + 5;
        else if (hour >= 22 || hour <= 5) baseValue = Math.floor(Math.random() * 3);
        else baseValue = Math.floor(Math.random() * 8) + 2;
        data[item][slot] = baseValue;
      });
    });
    return data;
  };

  // Get filtered time slots based on start and end time
  const getFilteredTimeSlots = () => {
    if (timeSlots.length === 0) return [];

    // Use the indices directly
    const startIdx = Math.min(startTimeIndex, endTimeIndex);
    const endIdx = Math.max(startTimeIndex, endTimeIndex);

    return timeSlots.slice(startIdx, endIdx + 1);
  };

  const displayTimeSlots = getFilteredTimeSlots();

  // Get color based on value
  const getColorByValue = (value, maxValue) => {
    if (value === 0) return '#f5f5f5';
    const ratio = value / maxValue;
    if (ratio >= 0.8) return '#1b5e20';
    if (ratio >= 0.6) return '#2e7d32';
    if (ratio >= 0.4) return '#4caf50';
    if (ratio >= 0.2) return '#a5d6a7';
    return '#e8f5e9';
  };

   const getFontColorByValue = (value, maxValue) => {
    if (value === 0) return 'black';
    const ratio = value / maxValue;
    if (ratio >= 0.8) return 'white';
    if (ratio >= 0.6) return 'white';
    if (ratio >= 0.4) return 'white';
    if (ratio >= 0.2) return 'black';
    return 'black';
  };

  // Get heatmap color
  const getHeatmapColor = (value, maxValue) => {
    if (value === 0) return '#ffffff';
    const ratio = value / maxValue;
    if (ratio >= 0.8) return '#d32f2f';
    if (ratio >= 0.6) return '#f44336';
    if (ratio >= 0.4) return '#ff9800';
    if (ratio >= 0.2) return '#ffc107';
    return '#fff9c4';
  };

  // Filter data based on search
  const filteredItems = Object.keys(peakData).filter(item =>
    search === '' || item.toLowerCase().includes(search.toLowerCase())
  );

  // Paginate
  const paginatedItems = filteredItems.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  // Calculate max value for color scaling
  const allValues = Object.values(peakData).flatMap(item =>
    Object.values(item)
  );
  const maxValue = Math.max(...allValues, 1);

  // Get row total
  // Get row total based on start and end time indices
  const getRowTotal = (item) => {
    const itemData = peakData[item];
    if (!itemData) return viewType === 'quantity' ? 0 : '0.00';

    // Use startTimeIndex and endTimeIndex directly
    const startIdx = Math.min(startTimeIndex, endTimeIndex);
    const endIdx = Math.max(startTimeIndex, endTimeIndex);

    const timeSlotKeys = Object.keys(itemData);
    const filteredValues = timeSlotKeys
      .filter(slot => {
        const slotIndex = timeSlots.indexOf(slot);
        return slotIndex >= startIdx && slotIndex <= endIdx;
      })
      .map(slot => itemData[slot] || 0);

    const sum = filteredValues.reduce((sum, val) => sum + val, 0);
    return viewType === 'price' ? sum.toFixed(2) : sum;
  };

  // Get peak hours for an item
  const getPeakHours = (itemData) => {
    const entries = Object.entries(itemData);
    const sorted = entries.sort((a, b) => b[1] - a[1]);
    return sorted.slice(0, 3).map(([time, value]) => ({ time, value }));
  };

  // Toggle row expansion
  const toggleRow = (item) => {
    setExpandedRows(prev => ({
      ...prev,
      [item]: !prev[item]
    }));
  };

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Handler for date filter change
  const handleDateFilterChange = (value) => {
    setDateFilter(value);

    const today = new Date();
    const currentDate = new Date();

    switch (value) {
      case 'all':
        setStartDate(null);
        setEndDate(null);
        break;
      case 'today':
        setStartDate(new Date(today.setHours(0, 0, 0, 0)));
        setEndDate(new Date(today.setHours(23, 59, 59, 999)));
        break;
      case 'thisWeek':
        const firstDayOfWeek = new Date(today);
        const diff = today.getDay() === 0 ? 6 : today.getDay() - 1;
        firstDayOfWeek.setDate(today.getDate() - diff);
        firstDayOfWeek.setHours(0, 0, 0, 0);

        const lastDayOfWeek = new Date(firstDayOfWeek);
        lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);
        lastDayOfWeek.setHours(23, 59, 59, 999);

        setStartDate(firstDayOfWeek);
        setEndDate(lastDayOfWeek);
        break;
      case 'thisMonth':
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        firstDayOfMonth.setHours(0, 0, 0, 0);

        const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        lastDayOfMonth.setHours(23, 59, 59, 999);

        setStartDate(firstDayOfMonth);
        setEndDate(lastDayOfMonth);
        break;
      case 'custom':
        // Keep existing dates or set to null
        break;
      default:
        break;
    }
  };


  const handleDownloadExcel = async () => {
    // console.log("Excel Start => ", startTimeIndex)
    // console.log("Excel End=> ", endTimeIndex)
    // setDownloading(true);
    try {
      // TODO: Replace with actual API call
      // const outletId = selectedOutlet === 'all' ? null : selectedOutlet;
      await downloadExcelGetPeakHoursItems(selectedOutlet, startDate, endDate, selectedCategory, viewType, startTimeIndex, endTimeIndex,dateFilter);
      // console.log("Download Excel - Outlet:", selectedOutlet, "Start Date:", startDate, "End Date:", endDate);
      // alert("Excel download will be implemented with backend API");
      // showSuccess("Excel Sheet Downloaded Successfully")
    } catch (error) {
      // console.error("Error downloading Excel:", error);
    } finally {
      // setDownloading(false);
    }
  };


  const handleExportPDF = async () => {
    // setDownloading(true);
    try {
      // Simulate PDF download
      // await new Promise(resolve => setTimeout(resolve, 1500));
      const response = await downloadPDFGetPeakHoursItemsReport(selectedOutlet, startDate, endDate, selectedCategory, viewType, startTimeIndex, endTimeIndex,dateFilter)
      // showSuccess("PDF Downloaded Successfully")
    } catch (error) {
      // console.error("Error downloading PDF:", error);
    } finally {
      // setDownloading(false);
    }
  };

  // Clear filters handler
  const handleClearFilters = () => {
    setSelectedOutlet('all');
    setDateFilter('all');
    setStartDate(null);
    setEndDate(null);
    setStartTime('00:00');
    setEndTime('23:00');
    setSearch('');
    setPage(0);
  };


  // Clear all filters
  // const handleClearFilters = () => {
  //   setSearch('');
  //   setSelectedOutlet('all');
  //   setStartDate(null);
  //   setEndDate(null);
  //   setStartTime('00:00');
  //   setEndTime('23:00');
  //   setPage(0);
  // };

  // Render Grid View
  const renderGridView = () => (
    <TableContainer sx={{ maxHeight: 600, borderRadius: '6px' }}>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                minWidth: 150,
                fontWeight: 'bold',
                position: 'sticky',
                left: 0,
                bgcolor: '#f5f5f5',
                zIndex: 3
              }}
            >
              <Typography variant="subtitle2" fontWeight="bold">Item Name</Typography>
            </TableCell>
            {displayTimeSlots.map(slot => (
              <TableCell
                key={slot}
                align="center"
                sx={{
                  minWidth: 55,
                  fontSize: '10px',
                  padding: '4px',
                  bgcolor: '#f5f5f5'
                }}
              >
                {slot}
              </TableCell>
            ))}
            <TableCell
              align="center"
              sx={{
                minWidth: 70,
                fontWeight: 'bold',
                bgcolor: '#f5f5f5'
              }}
            >
              Total
            </TableCell>
            {/* <TableCell 
              align="center"
              sx={{ 
                minWidth: 120,
                fontWeight: 'bold',
                bgcolor: '#f5f5f5'
              }}
            >
              Peak Hours
            </TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {paginatedItems.length === 0 ? (
            <TableRow>
              <TableCell colSpan={displayTimeSlots.length + 3} align="center" sx={{ py: 4 }}>
                <Typography color="text.secondary">No data found</Typography>
              </TableCell>
            </TableRow>
          ) : (
            paginatedItems.map((item) => {
              const itemData = peakData[item];
              const total = getRowTotal(item);
              const peaks = getPeakHours(itemData);

              return (
                <React.Fragment key={item}>
                  <TableRow hover>
                    <TableCell
                      sx={{
                        fontWeight: 500,
                        position: 'sticky',
                        left: 0,
                        bgcolor: 'white',
                        zIndex: 2
                      }}
                    >
                      <Box display="flex" alignItems="center" gap={1} sx={{ mb: 2 }}>
                        {/* <IconButton size="small" onClick={() => toggleRow(item)}>
                          {expandedRows[item] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton> */}
                        {item}
                      </Box>
                    </TableCell>

                    {displayTimeSlots.map(slot => {
                      const value = itemData[slot] || 0;
                      const bgColor = selectedView === 'heatmap'
                        ? getHeatmapColor(value, maxValue)
                        : getColorByValue(value, maxValue);

                      return (
                        <TableCell
                          key={slot}
                          align="center"
                          sx={{
                            bgcolor: bgColor,
                            padding: '4px',
                            fontWeight: value > 0 ? '500' : 'normal',
                            color: getFontColorByValue(value,maxValue)
                          }}
                        >
                          <Tooltip title={`${item}: ${slot} - ${value} orders`}>
                            <span>{value}</span>
                          </Tooltip>
                        </TableCell>
                      );
                    })}

                    <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                      {total}
                    </TableCell>

                    {/* <TableCell align="center">
                      <Box>
                        {peaks.map((peak, idx) => (
                          <Chip
                            key={idx}
                            label={`${peak.time} (${peak.value})`}
                            size="small"
                            color={idx === 0 ? 'error' : idx === 1 ? 'warning' : 'info'}
                            variant="outlined"
                            sx={{ m: 0.5, fontSize: '9px' }}
                          />
                        ))}
                      </Box>
                    </TableCell> */}
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={displayTimeSlots.length + 3} sx={{ p: 0 }}>
                      <Collapse in={expandedRows[item]} timeout="auto" unmountOnExit>
                        <Box sx={{ p: 2, bgcolor: '#fafafa' }}>
                          <Typography variant="subtitle2" gutterBottom>
                            Peak Hour Analysis for {item}
                          </Typography>
                          <Grid container spacing={2}>
                            {peaks.map((peak, idx) => (
                              <Grid item xs={12} sm={6} md={4} key={idx}>
                                <Paper sx={{ p: 2, bgcolor: '#e8f5e9' }}>
                                  <Typography variant="caption" color="text.secondary">
                                    Peak #{idx + 1}
                                  </Typography>
                                  <Typography variant="h6">
                                    {peak.time}
                                  </Typography>
                                  <Typography variant="body2">
                                    {peak.value} orders
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary">
                                    {((peak.value / total) * 100).toFixed(1)}% of total
                                  </Typography>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              );
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ width: '100%', p: 3 }}>
        {/* Header */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box sx={{ mb: 4 }}>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              Items Peak Hours Management
            </Typography>
            <Typography color="text.secondary" variant="body1">
              Monitor menu item performance across 24-hour time slots
            </Typography>
          </Box>
          <Box>
            <Button variant='contained' sx={{ mr: 1 }} onClick={handleDownloadExcel} startIcon={<TableChart />} >Download Excel </Button>
            <Button variant='contained' onClick={handleExportPDF} startIcon={<PictureAsPdf />}>Download PDF</Button>
          </Box>
        </Box>

        {/* Filters Section */}
        <Paper sx={{ p: 3, mb: 3 }}>
          <Grid container spacing={2} alignItems="center">
            {/* Outlet Filter */}
            <Grid item xs={12} sm={6} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Outlet</InputLabel>
                <Select
                  value={selectedOutlet}
                  disabled={JSON.parse(localStorage.getItem('admin_outlet_id'))}
                  label="Outlet"
                  onChange={(e) => {
                    setSelectedOutlet(e.target.value)
                    if (e.target.value) {
                      setStartTimeIndex(0)
                      setEndTimeIndex(23)
                      setStartTime('00:00')
                      setEndTime('23:00')
                    }

                  }}
                  startAdornment={
                    <InputAdornment position="start">
                      <StorefrontIcon fontSize="small" />
                    </InputAdornment>
                  }
                  MenuProps={{
                    disableScrollLock: true,
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                      },
                    },
                  }}
                >
                  <MenuItem value="all">All Outlets</MenuItem>
                  {outlets.map((outlet) => (
                    <MenuItem key={outlet.id} value={outlet.id}>
                      {outlet.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Category Filter */}
            <Grid item xs={12} sm={6} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Category</InputLabel>
                <Select
                  value={selectedCategory}
                  label="Category"
                  onChange={(e) => setSelectedCategory(e.target.value)}
                  startAdornment={
                    <InputAdornment position="start">
                      <Category fontSize="small" />
                    </InputAdornment>
                  }
                  MenuProps={{
                    disableScrollLock: true,
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                      },
                    },
                  }}
                >
                  <MenuItem value="all">All Categories</MenuItem>
                  {categories.map((category) => (
                    <MenuItem key={category.id} value={category.id}>
                      {category.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Start Time */}
            <Grid item xs={12} sm={6} md={1.5}>
              <CustomTimeSelect
                label="Start Time"
                value={startTime}
                onChange={setStartTime}
                placeholder="00:00"
                icon={HourglassBottomIcon}
                timeIndex={setStartTimeIndex}
                timeSlots={timeSlots}
              />
            </Grid>

            {/* End Time */}
            <Grid item xs={12} sm={6} md={1.5}>
              <CustomTimeSelect
                label="End Time"
                value={endTime}
                onChange={setEndTime}
                placeholder="23:00"
                icon={HourglassTopIcon}
                timeIndex={setEndTimeIndex}
                timeSlots={timeSlots}
              />
            </Grid>

            {/* Search */}
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                size="small"
                placeholder="Search items..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(0);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {/* Action Buttons */}
            <Grid item xs={12} md={1}>
              <Button
                fullWidth
                variant="outlined"
                startIcon={<Clear />}
                onClick={handleClearFilters}
                size="small"
              >
                Clear
              </Button>
            </Grid>
          </Grid>

          {/* Date Filter Section - New Row */}
          <Box sx={{ mt: 3, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2 }}>
            {/* Date Filter Dropdown */}
            <FormControl size="small" sx={{ minWidth: '180px', mt: 1 }}>
              <InputLabel sx={{ mt: 0.65 }}>Date Filter</InputLabel>
              <Select
                value={dateFilter}
                label="Date Filter"
                onChange={(e) => handleDateFilterChange(e.target.value)}
                startAdornment={
                  <InputAdornment position="start">
                    <CalendarIcon fontSize="small" />
                  </InputAdornment>
                }
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="today">Today</MenuItem>
                <MenuItem value="thisWeek">This Week</MenuItem>
                <MenuItem value="thisMonth">This Month</MenuItem>
                <MenuItem value="custom">Custom</MenuItem>
              </Select>
            </FormControl>

            {/* Start Date - Only show when Custom is selected */}
            {dateFilter === 'custom' && (
              <DatePicker
                label="Start Date"
                value={startDate}
                onChange={(newValue) => setStartDate(newValue)}
                format="dd-MM-yyyy"
                slotProps={{
                  textField: {
                    size: 'small',
                    sx: { width: '180px', mt: 1 },
                    InputProps: {

                      startAdornment: (
                        <InputAdornment position="start">
                          <CalendarIcon fontSize="small" />
                        </InputAdornment>
                      )
                    }
                  }
                }}
              />
            )}

            {/* End Date - Only show when Custom is selected */}
            {dateFilter === 'custom' && (
              <DatePicker
                label="End Date"
                value={endDate}
                onChange={(newValue) => setEndDate(newValue)}
                format="dd-MM-yyyy"
                minDate={startDate || undefined} // Prevent selecting before start date
                disabled={!startDate} // Disable if no start date selected
                slotProps={{
                  textField: {
                    size: 'small',
                    sx: { width: '180px', mt: 1 },
                    InputProps: {
                      min: startDate || undefined, // Can't select end date before start date
                      max: new Date().toISOString().split('T')[0],// Can't select future dates (optional)
                      startAdornment: (
                        <InputAdornment position="start">
                          <CalendarIcon fontSize="small" />
                        </InputAdornment>
                      )
                    }
                  }
                }}
              />
            )}

            {/* Radio Buttons for Quantity and Price */}
            <FormControl component="fieldset" size="small">
              <RadioGroup
                row
                value={viewType}
                onChange={(e) => setViewType(e.target.value)}
                sx={{ display: 'flex', gap: 1 }}
              >
                <FormControlLabel
                  value="quantity"
                  control={<Radio size="small" />}
                  label="Quantity"
                />
                <FormControlLabel
                  value="price"
                  control={<Radio size="small" />}
                  label="Price"
                />
              </RadioGroup>
            </FormControl>
          </Box>

        </Paper>

        {/* Info Alert */}
        <Alert severity="info" sx={{ mb: 3 }}>
          <Typography variant="body2">
            <strong>Time Range:</strong> {startTime} - {endTime} |
            <strong> Total Items:</strong> {items.length} |
            <strong> Time Slots:</strong> {displayTimeSlots.length} displayed
          </Typography>
        </Alert>

        {/* Main Grid */}
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
          {renderGridView()}

          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            component="div"
            count={filteredItems.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} of ${count}`}
          />
        </Paper>

        {/* Legend */}
        {/* <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 3, flexWrap: 'wrap' }}>
          <Box display="flex" alignItems="center" gap={1}>
            <Box sx={{ width: 20, height: 20, bgcolor: '#e8f5e9', border: '1px solid #ccc' }} />
            <Typography variant="caption">Low (0-20%)</Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <Box sx={{ width: 20, height: 20, bgcolor: '#a5d6a7', border: '1px solid #ccc' }} />
            <Typography variant="caption">Medium (20-40%)</Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <Box sx={{ width: 20, height: 20, bgcolor: '#4caf50', border: '1px solid #ccc' }} />
            <Typography variant="caption">High (40-60%)</Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <Box sx={{ width: 20, height: 20, bgcolor: '#2e7d32', border: '1px solid #ccc' }} />
            <Typography variant="caption">Very High (60-80%)</Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <Box sx={{ width: 20, height: 20, bgcolor: '#1b5e20', border: '1px solid #ccc' }} />
            <Typography variant="caption">Peak (80-100%)</Typography>
          </Box>
        </Box> */}

        {/* Summary Stats */}
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
          <Typography variant="caption" color="text.secondary">
            Total Items: {filteredItems.length} | Displaying: {paginatedItems.length} items
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Time Range: {startTime} - {endTime}
            {selectedOutlet !== 'all' && ` | Outlet: ${outlets.find(o => o.id === selectedOutlet)?.name}`}
            {startDate && ` | From: ${startDate.toLocaleDateString()}`}
            {endDate && ` | To: ${endDate.toLocaleDateString()}`}
          </Typography>
        </Box>
      </Box>
    </LocalizationProvider>
  );
}

export default PeakHoursItemsManagement;